import { io, Socket } from "socket.io-client";

/** Адрес сокет-сервера; REACT_APP_SOCKET_URL нужен только для локальной отладки */
const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "https://api.manipulyatr.ru";

/** Подключение к сокет-серверу площадки с токеном текущего пользователя */
export function createSocket(): Socket {
  return io(SOCKET_URL, {
    auth: {
      token: localStorage.getItem("token") || "",
    },
    transports: ["websocket"],
  });
}
